// when on page 1 , status is created
// when on page 2, it means you completed BASIC section
// when on page 3, you are still on basic
// when on page 4, you are still on basic.
// when on page5, means you completed TERMS
// when submitted, status will change to INREVIEW. (however draft would still have last status which would be TERMS)
const formStatusesByCurrentPage = {
    1: 'CREATED',
    2: 'BASIC',
    3: 'BASIC',
    4: 'BASIC',
    5: 'TERMS',
};

export { formStatusesByCurrentPage };
